import { Principal } from "@icp-sdk/core/principal";
import { isIcpAccountIdentifier } from "@icp-sdk/canisters/ledger/icp";
import { decodeIcrcAccount } from "./icrcAccount";
export const HEX_REGEX = new RegExp("^[A-Fa-f0-9]+$");
export function toTitleCase(str) {
    return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}
export function isPrincipalValid(text) {
    try {
        Principal.fromText(text);
        return true;
    }
    catch (_e) {
        return false;
    }
}
export function isSubAccountValid(text) {
    return text.length <= 64 && isHexString(text);
}
// Length, hex and the CRC32 in the first four bytes. Length and hex alone let a typo through to
// the canister, whose AccountIdentifier::from_slice checks the checksum and rejects it - by which
// point the user had already been told the address was fine.
export function isAccountIdentifierValid(text) {
    return isIcpAccountIdentifier(text);
}
export function isICRCAddressValid(text) {
    try {
        decodeIcrcAccount(text);
        return true;
    }
    catch (_e) {
        return false;
    }
}
export function isHexString(text) {
    return HEX_REGEX.test(text);
}
export function isUrl(text) {
    try {
        new URL(text);
        return true;
    }
    catch {
        return false;
    }
}
